import { render } from "./LegItineraryList.vue?vue&type=template&id=0b84d999&scoped=true&lang=pug"
import script from "./LegItineraryList.vue?vue&type=script&lang=ts"
export * from "./LegItineraryList.vue?vue&type=script&lang=ts"

import "./LegItineraryList.vue?vue&type=style&index=0&id=0b84d999&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0b84d999"

export default script